<template>
  <div class="w-auto d-flex align-items-center justify-content-center">
    <BImg
      fluid
      v-if="
        attachmentDetails.resourceDetailAttachmentType == 1 // Image
      "
      width="100px"
      :src="`${baseUrl}/${attachmentDetails.resourceDetailAttachmentLink}`"
    ></BImg>
    <audio
      class="custom-media"
      controls
      v-else-if="
        attachmentDetails.resourceDetailAttachmentType == 2 // Voice
      "
    >
      <source
        :src="`${baseUrl}/${attachmentDetails.resourceDetailAttachmentLink}`"
      />
    </audio>

    <video
      v-else-if="
        attachmentDetails.resourceDetailAttachmentType == 3 // Video
      "
      preload="metadata"
      class="rounded-lg custom-media"
      controls
      height="auto"
    >
      <source
        :src="`${baseUrl}/${attachmentDetails.resourceDetailAttachmentLink}`"
      />
    </video>
    <a
      target="_blank"
      :href="`${baseUrl}/${attachmentDetails.resourceDetailAttachmentLink}`"
      v-else-if="
        attachmentDetails.resourceDetailAttachmentType == 4 // PDF
      "
    >
      <PdfIcon class="custom-icon"></PdfIcon>
    </a>
    <a
      target="_blank"
      :href="`${baseUrl}/${attachmentDetails.resourceDetailAttachmentLink}`"
      v-else-if="
        attachmentDetails.resourceDetailAttachmentType == 5 // Archive
      "
    >
      <ArchiveIcon class="custom-icon" style="color: #555ad4"></ArchiveIcon>
    </a>
    <!-- <FeatherIcon size="45" icon="FileTextIcon"></FeatherIcon> -->
  </div>
</template>

<script>
export default {
  props: {
    attachmentDetails: {
      type: Object,
    },
  },
  data() {
    return {
      attachmentTypes: {
        1: "تصویر",
        2: "صدا",
        3: "ویدیو",
        4: "PDF",
        5: "فایل فشرده",
      },
    };
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    PdfIcon,
    ArchiveIcon,
    BButton,
    BImg,
  },
};
import PdfIcon from "@/views/components/Icons/PdfIcon.vue";
import ArchiveIcon from "@/views/components/Icons/ArchiveIcon.vue";
import { BImg, BButton } from "bootstrap-vue";
</script>
<style scoped>
@media only screen and (max-width: 468px) {
  .custom-media {
    width: 200px;
  }
}
@media only screen and (min-width: 469px) {
  .custom-media {
    width: 300px;
  }
}
.custom-icon {
  width: 5rem;
  height: 5rem;
}
</style>
